import { render, staticRenderFns } from "./TrendSearchGroup.vue?vue&type=template&id=6e947f4d"
import script from "./TrendSearchGroup.vue?vue&type=script&lang=js"
export * from "./TrendSearchGroup.vue?vue&type=script&lang=js"
import style0 from "./TrendSearchGroup.vue?vue&type=style&index=0&id=6e947f4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports